import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router";
import moment from "moment";

import WithdrawalHistory from "@app/dev/terminal/containers/bethistory/components/withdrawalHistory";
import ToastWrapper from "@common/helpers/toastWrapper";
import HistoryHeader from "./components/header";
import SportHistory from "./components/sportHistory/sportHistory";
import TransactionHistory from "./components/transactionHistory/transactionHistory";

import "./style.scss";

const initialDateFilter = [moment().utc().startOf("D").toDate(), new Date()];

const BetHistory = () => {
  const [dateFilter, setDateFilter] = useState(initialDateFilter);
  const [activeTab, setActiveTab] = useState("Sport");
  const user = useSelector((state) => state.user);
  const { loggedIn, loggedInByRFID } = user;

  const [start, end] = dateFilter;

  const changeDateFilter = ([newStart, newEnd]) => {
    if (activeTab === "Casino" || activeTab === "Withdrawal") {
      const diff = moment(newEnd).diff(moment(newStart), "days");
      if (diff > 31) {
        setDateFilter(initialDateFilter);
        return ToastWrapper("error", "You can select maximum 31 days");
      }
    }

    const formattedEnd = newEnd ? moment(newEnd).endOf("day").toDate() : null;

    setDateFilter([newStart && moment(newStart).toDate(), formattedEnd]);
  };

  const isLoggedIn = loggedIn || loggedInByRFID;

  if (!isLoggedIn) return <Navigate to="/" />;

  const componentMap = {
    Sport: SportHistory,
    Casino: TransactionHistory,
    Withdrawal: WithdrawalHistory,
  };

  const Component = componentMap[activeTab];

  const selectActiveTab = (tab) => {
    setDateFilter(initialDateFilter);
    setActiveTab(tab);
  };

  return (
    <div className="ticket-table-wrp ">
      <HistoryHeader
        activeTab={activeTab}
        selectActiveTab={selectActiveTab}
        changeDateFilter={changeDateFilter}
        start={start}
        end={end}
      />
      <Component start={start} end={end} />
    </div>
  );
};
export default BetHistory;
